import EducationDetails from "./EducationDetails";
export default EducationDetails;
